import { render, staticRenderFns } from "./PrintProforma.vue?vue&type=template&id=ed135be4&"
import script from "./PrintProforma.vue?vue&type=script&lang=js&"
export * from "./PrintProforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports